import type { SideBarDef } from '@ag-grid-community/core';

/**
 * Default sidebar configuration for cdw-search-grid with column tool panel
 * Based on implementation from little-sis-cloud-webapp
 */
export const CDW_DEFAULT_SIDEBAR: SideBarDef = {
  position: 'left',
  defaultToolPanel: '',
  hiddenByDefault: false,
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnFilter: false, // Enables search in column list
        suppressColumnSelectAll: false, // Enables select/deselect all checkbox
        suppressColumnExpandAll: false, // Enables expand/collapse all
        suppressColumnMove: false, // Enable drag-and-drop reordering in column selector
      },
    },
  ],
};
